module.exports = __webpack_public_path__ + "img/95e7afe.jpg";